import { useEffect, useState } from 'react';

const useIsIframeOn = () => {
  const [isIframeOn, setIsIframeOn] = useState<boolean>(false);

  const checkIFrames = () =>
    document.querySelectorAll('.process-payment--challenge').length > 0;

  useEffect(() => {
    setIsIframeOn(checkIFrames());

    // Create observer to monitor changes
    const observer = new MutationObserver(() => {
      setIsIframeOn(checkIFrames());
    });

    // Start observing the document with the configured parameters
    observer.observe(document, { childList: true, subtree: true });

    // Make sure to disconnect the observer when component unmounts
    return () => observer.disconnect();
  }, []);

  return isIframeOn;
};

export { useIsIframeOn };
